module.exports = __webpack_public_path__ + "static/media/student42.4e3cd8bf.png";